import DialogContentText from "@mui/material/DialogContentText";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import moment from "moment";
import React, { useState, useEffect } from "react";

import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import GenericModal from "../../../../modal-closebtn";

const ModelerModalDueDate = ({ FormComponents, saveDate, element, label }) => {
  const [openDialog, setOpenDialog] = useState(true);
  const [milliseconds, setMilliseconds] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [hours, setHours] = useState(0);
  const [days, setDays] = useState(0);
  const [weeks, setWeeks] = useState(0);
  const [months, setMonths] = useState(0);
  const [years, setYears] = useState(0);

  useEffect(() => {
    if (FormComponents && FormComponents.length === 0) return;

    const datas = moment.duration(FormComponents);
    if (datas.isValid()) {
      setMilliseconds(datas.milliseconds());
      setSeconds(datas.seconds());
      setMinutes(datas.minutes());
      setHours(datas.hours());
      setDays(datas.days());
      setWeeks(datas.weeks());
      setMonths(datas.months());
      setYears(datas.years());
    }
  }, [FormComponents]);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleOpen = () => {
    setOpenDialog(true);
  };

  const handleSave = () => {
    let period = "";
    let time = "";
    period = years > 0 ? `${years}Y` : "";
    period += months > 0 ? `${months}M` : "";
    period += weeks > 0 ? `${weeks}W` : "";
    period += days > 0 ? `${days}D` : "";

    time = hours > 0 ? `${hours}H` : "";
    time += minutes > 0 ? `${minutes}M` : "";
    time += seconds > 0 ? `${seconds}S` : "";

    const result =
      (period.length > 0 ? `P${period}` : "") +
      (period.length > 0 && time.length > 0
        ? `T${time}`
        : period.length <= 0 && time.length > 0
          ? `PT${time}`
          : "");
    saveDate(element, result);
    setOpenDialog(false);
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    const numValue = Math.max(0, parseInt(value) || 0);
    
    switch (name) {
      case "milliseconds":
        setMilliseconds(numValue);
        break;
      case "seconds":
        setSeconds(numValue);
        break;
      case "minutes":
        setMinutes(numValue);
        break;
      case "hours":
        setHours(numValue);
        break;
      case "days":
        setDays(numValue);
        break;
      case "weeks":
        setWeeks(numValue);
        break;
      case "months":
        setMonths(numValue);
        break;
      case "years":
        setYears(numValue);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <Provider>
        <GenericModal
          title={label}
          handleSubmit={() => handleSave()}
          handleClose={handleClose}
          btnActionTitle={language.confirm}
          btnCancelTitle={language.cancel}
          size="md"
          open={openDialog}
        >
          <>
            <DialogContentText>
              {language.dueDateModalContent}
            </DialogContentText>

            <FormControl style={{ width: "20%", margin: "1%" }}>
              <TextField
                onChange={onChange}
                name="years"
                variant="outlined"
                label={language.dueDateYears}
                type="number"
                value={years}
              />
            </FormControl>
            <FormControl style={{ width: "20%", margin: "1%" }}>
              <TextField
                onChange={onChange}
                name="months"
                variant="outlined"
                label={language.dueDateMonth}
                type="number"
                value={months}
              />
            </FormControl>
            <FormControl style={{ width: "20%", margin: "1%" }}>
              <TextField
                onChange={onChange}
                name="weeks"
                variant="outlined"
                label={language.dueDateWeeks}
                type="number"
                value={weeks}
              />
            </FormControl>
            <FormControl style={{ width: "20%", margin: "1%" }}>
              <TextField
                onChange={onChange}
                name="days"
                variant="outlined"
                label={language.dueDateDays}
                type="number"
                value={days}
              />
            </FormControl>
            <FormControl style={{ width: "20%", margin: "1%" }}>
              <TextField
                onChange={onChange}
                name="hours"
                variant="outlined"
                label={language.dueDateHour}
                type="number"
                value={hours}
              />
            </FormControl>
            <FormControl style={{ width: "20%", margin: "1%" }}>
              <TextField
                onChange={onChange}
                name="minutes"
                variant="outlined"
                label={language.dueDateMin}
                type="number"
                value={minutes}
              />
            </FormControl>
            <FormControl style={{ width: "20%", margin: "1%" }}>
              <TextField
                onChange={onChange}
                name="seconds"
                variant="outlined"
                label={language.dueDateSec}
                type="number"
                value={seconds}
              />
            </FormControl>
          </>
        </GenericModal>
      </Provider>
    </div>
  );
};

export default ModelerModalDueDate;
